<template>
  <div class="get_list_wrapper">
    <div class="list">
      <div class="lsit_l">
        <img src="https://wx.qlogo.cn/mmopen/vi_32/DYAIOgq83epSMk4WBNxA9cuX3iaYuKDldUzfibVrmjs5uBg92X061FpyHmrXBGsLSenkhnlcpuYm4CEBFSocyGtg/132" class="user_pic" />
      </div>
      <div class="lsit_c">
        <div class="title">小咩咩</div>
        <div class="coins"><img src="../../../images/yuanbao.png" class="yuanbao" /><span class="coins_num">券币＋10</span></div>
        <div class="time">昨天 12:45:06</div>
      </div>
      <div class="lsit_r">
        <img src="https://wx.qlogo.cn/mmopen/vi_32/DYAIOgq83epSMk4WBNxA9cuX3iaYuKDldUzfibVrmjs5uBg92X061FpyHmrXBGsLSenkhnlcpuYm4CEBFSocyGtg/132" class="title_pic" />
      </div>
    </div>
  </div>
</template>
<script type = "text/ecamscript-6">
/* eslint-disable */
  export default {
    name:"getCoins",
  }
</script>
<style lang="stylus">
  .get_list_wrapper
    .list
      padding:20px 20px 20px 40px
      box-sizing:border-box
      background:#fff
      border-bottom:1px solid #e6e6e6
      /*px*/
      display:flex
      .lsit_l
        flex:0 0 125px
        .user_pic
          width:90px
          height:90px
          border-radius:45px
          display:block
      .lsit_c
        flex:1
        .title
          font-size:28px
          color:#ff6e25
        .coins
          margin-top:15px
          .yuanbao
            width:44px
            height:38px
            vertical-align:middle
          .coins_num
            font-size:24px
            color:#333
        .time
          color:#808080
          font-size:24px
          margin-top:15px
      .lsit_r
        flex:0 0 120px
        .title_pic
          width:120px
          height:120px
          display:block

</style>



// WEBPACK FOOTER //
// src/components/userCenter/news/getCoins.vue